<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div ref="printBill" class="centerBox2">
      <div>
        <div ref="printBill" class="" id="contractdiv">
          <div><img src="static/favicon.png"></div>
          <div><img src="static/favicon.png" style="width: 120px;"></div>
          <h1 align="center" style="font-family: 宋体;color: black"><span style="font-family: 微软雅黑">HelloKid</span><span
            style="font-family: 宋体;margin-left: 10px;color: black">课程购买凭据</span></h1>
          <div style="margin-top: 40px">
            <div style="margin-top:20px">
              <div style="float: left;font-size: 12pt;color: black">
                订单编号:<span>{{orderNum}}</span>
              </div>
              <div style="float: right;font-size: 12pt;color: black">
                购买日期:<span>{{orderDate}}</span>
              </div>
            </div>
            <table class="MsoNormalTable" cellspacing="0" cellpadding="0">
              <tbody>
              <tr>
                <td class="name">学员ID：<span>{{userId}}</span></td>
                <td class="name">学员姓名:<span></span>{{nickName}}</td>
                <td class="name">学员账号:<span>{{mobile}}</span></td>
              </tr>
              <tr>
                <td class="name">课程方案：</td>
                <td class="value" colspan="2">{{lessonStr}}</td>
              </tr>
              <tr v-if="discountNum > 0">
                <td class="name">课时赠送：</td>
                <td class="value" colspan="2">{{discountNum}}节外教课</td>
              </tr>
              <tr>
                <td class="name">配送教材：</td>
                <td class="value" colspan="2">{{bookNum}}</td>
              </tr>
              <tr>
                <td class="name">配送地址:</td>
                <td class="value" colspan="2">{{address}}</td>
              </tr>
              <tr v-if="needContract == 1">
                <td class="name">需要合同:</td>
                <td class="value" colspan="2" v-if="needContract == 1">是</td>
              </tr>
              <tr v-if="needInvoice == 1">
                <td class="name">需要发票:</td>
                <td class="value" colspan="2" v-if="needInvoice == 1">{{invoiceDetail}}</td>
              </tr>
              </tbody>
            </table>
            <div style="margin-top: 30px">
              <div style="margin-top:20px">
                <table class="MsoNormalTable" cellspacing="0" cellpadding="0">
                  <tbody>
                  <tr v-if="discount > 0">
                    <td class="name">课程原价：{{amount}} 元</td>
                    <td class="name">现金减免：{{discount}}</td>
                  </tr>
                  <tr>
                    <td class="name">实付金额(小写)：{{payAmount}} 元</td>
                    <td class="name">合计人民币(大写)：{{payAmountCN}}</td>
                  </tr>
                  <tr>
                    <td colspan="2" class="name">专属服务热线: 0571-8607-0186</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div style="margin-top: 30px;font-size: 11pt;color: black">
                <div style="margin-top: 20px;font-size: 11pt;color: black">
                  <div style="float: left"><span>开票单位:杭州凯伯顿科技有限公司</span></div>
                  <div style="float: right"><span style="margin-left:20px">会计: {{auditUser}}</span><span
                    style="margin-left: 20px">出纳: 许志成</span><span
                    style="margin-left: 20px">开票人: {{createUser}}</span></div>
                </div>
                <div style="margin-top: 30px;font-size: 11pt;color: black">
                  <div style="margin-top: 20px;font-size: 11pt;color: black">
                    <div style="float: left;color: #e60000"><span>温馨提示：宝贝开课30天内请务必与课程老师确认教材是否寄送且签收，并确认教材是否正确。开课30天后教材问题不予负责</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="toolbar not-print">
                <div class="toolbar_inbox">
                  <a href="#" style="float:right;" v-on:click="printWeb()" class="toolbtn" title="打印本凭据"
                     name="cont_print">打印本凭据</a>
                </div>
                <div class="toolbar_inbox">
                  <button href="#" style="float:right;" @click="cancelPrint" class="toolbtn" title="放弃打印"
                          name="cancel_print">放弃打印
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  export default {
    data() {
      return {
        orderNum: '',
        orderDate: '',
        userId: '',
        mobile: '',
        nickName: '',
        address: '',
        amount: '',
        lessonStr: '',
        bookNum: '',
        createUser: '',
        auditUser: '',
        discount: '',
        discountNum: '',
        payAmount: '',
        payAmountCN: '',
        needInvoice: '',
        needContract: '',
        invoiceDetail: '',
      }
    },
    mounted: function () {
      let self = this
      this.orderNum = this.$route.query.orderSn
      this.$http.post('/fundPackage/getFundPackage', {orderSn: this.orderNum}).then(function (res) {
        let time = new Date((res.data.createTime) * 1000)
        self.orderDate = time.getFullYear() + '年' + (time.getMonth() + 1) + '月' + time.getDate() + '日'
        self.userId = res.data.uid
        self.mobile = res.data.mobile
        self.nickName = res.data.nickname
        self.bookNum = res.data.bookNum
        self.amount = res.data.amount
        self.createUser = res.data.adminName
        self.auditUser = res.data.auditName
        self.address = res.data.address
        self.discount = res.data.discount
        self.discountNum = res.data.discountNum
        self.payAmount = res.data.payAmount
        self.payAmountCN = res.data.chineseMoney
        self.needContract = res.data.needContract
        self.needInvoice = res.data.needInvoice
        self.invoiceDetail = res.data.invoiceDetail
        if (res.data.num) {
          self.lessonStr = self.lessonStr + res.data.num + '外教课时'
        }
        if (res.data.livingNum) {
          if (self.lessonStr) {
            self.lessonStr = self.lessonStr + '+' + res.data.livingNum + '直播课时'
          } else {
            self.lessonStr = self.lessonStr + res.data.livingNum + '直播课时'
          }
        }
        if (res.data.chineseNum) {
          if (self.lessonStr) {
            self.lessonStr = self.lessonStr + '+' + res.data.chineseNum + '中教课时'
          } else {
            self.lessonStr = self.lessonStr + res.data.chineseNum + '中教课时'
          }
        }
      })
    },
    methods: {
      cancelPrint() {
        this.$router.push({path: '/order/fundPackageList'})
      },
      printWeb() {
        document.body.innerHTML = this.$refs.printBill.innerHTML
        window.print()
      },
    }
  }
</script>




// WEBPACK FOOTER //
// UserCredential2.vue?6c4825d1